<template>
  <div
    class="pw-dropdown-item__wrap"
    :class="{ 'pw-dropdown-item__wrap--unclickable': !clickable }"
  >
    <div v-if="!clickable" class="pw-dropdown-item pw-dropdown-item--unclickable">
      <slot />
    </div>
    <div
      v-if="clickable"
      class="pw-dropdown-item"
      :class="{ 'pw-dropdown-item--has-child': containChild }"
      @click="$emit('click')"
    >
      <slot v-if="!containChild" />
      <div class="pw-dropdown-item__with-child" v-if="containChild">
        <span>
          {{ text }}
          <i class="mdi mdi-chevron-right"></i>
        </span>
        <div class="pw-dropdown-item__children">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DropdownItem',
  props: {
    containChild: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '',
    },
    clickable: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss">
.is-bottom-right {
  .pw-dropdown-item__children {
    transform: translateX(calc(-100% + -4px)) !important;
  }
}
.pw-dropdown-item__children {
  position: absolute;
  right: 0;
  top: -14px;
  width: 100%;
  background-color: #fff;
  padding: 4px;
  box-shadow: 0 3px 6px 0 #d8e3eb;
  transform: translateX(calc(100% + 15px));
  opacity: 0;
  transition: all 0.3s ease-in-out;
  pointer-events: none;
}
.pw-dropdown-item__with-child {
  position: relative;
  span {
    display: block;
    position: relative;
    .mdi {
      position: absolute;
      right: 0;
    }
  }
}

.pw-dropdown-item--has-child {
  &:hover {
    .pw-dropdown-item__children {
      display: block;
      opacity: 1;
      pointer-events: all;
    }
  }
}

.pw-dropdown-item__wrap {
  &--unclickable {
    //pointer-events: none !important;
  }
}

.pw-dropdown-item {
  font-size: 14px;
  color: #333;
  line-height: 1.36;
  padding: 8px 12px;
  &--unclickable {
    &:hover {
      cursor: inherit !important;
      background: #fff !important;
    }
  }
  &:hover {
    cursor: pointer;
    background-color: #ebf0f3;
  }
}
</style>
